/*******************************************************************************
 * Copyright (c) 2019-2021 Singularity AI, Inc. - All Rights Reserved
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 ******************************************************************************/
/* import */
import { gql } from 'graphql-tag';
/* AppSync */
import { appsyncclient} from '../../api/AppSync';
import { workListTabs, workListImgTabs, tameUsers } from "../mock/myworklist";
import actions from "../constant";
import { isExportDeclaration } from 'typescript';
/* GraphQL */
const initialState = {
  tableData: [],
  images: {},
  assignList: []
};
/*******************************************************************************
 * main
 ******************************************************************************/
export function worklistReducer(state = initialState, action) {
  switch (action.type) {
    case 'worklist/WorklistAdded': {
      // return {...state, action.payload};
    }

    case 'worklist/WorklistLoaded': {
      // return action.payload;
    }

    case actions.GET_WORK_TABLES: {
      return {...state, tableData: action.payload}
    }

    case actions.GET_WORK_IMG_TABLES: {
      return {...state, images: { ...state.images, ...action.payload}}
    }

    case actions.GET_ASSIGN_LIST: {
      return { ...state, assignList: action.payload }
    }

    default:
      return state;
  };
};

// Thunk function
/**
 * 获取myworklist 表格的数据
 * @returns 
 */
export const getMyWorkTables = () => {
  return (dispatch, getState) => {
    dispatch({ type: actions.GET_WORK_TABLES, payload: workListTabs})
  }
};

/**
 * 获取smyworklist 下某个case的图片
 * @param {*} data 
 * @returns 
 */
export const getMyWorkImgTables = ({id}) => {

  const imgs = workListImgTabs[id] || [];
  return (dispatch, getState) => {
    dispatch({ type: actions.GET_WORK_IMG_TABLES, payload: { [id]: imgs } })
  }
};

/**
 * 编辑case表单提交
 * @param {*} param 
 */
export const editCaseSubmit = (param) => {
  alert(JSON.stringify(param))
};

export const getAssignList = () => {
  return (dispatch, getState) => {
    dispatch({ type: actions.GET_ASSIGN_LIST, payload: tameUsers})
  }
};

// 搜索表格
export const searchTable = (values) => (dispatch, getState) => {
  alert(`搜索表格 ${JSON.stringify(values)}`)
};

// 编辑case
export const editCase = ( values ) => (dispatch, getState) => {
  alert(`编辑case ${JSON.stringify(values)}`)
};

// 创建case
export const createCase = (values) => (dispatch, getState) => {
  alert(`创建case ${JSON.stringify(values)}`)
}